export const TimeINTimeOUTTypes = {
    TIME_IN: 'TIME_IN',
    TIME_OUT: 'TIME_OUT',  
    WORK_TIME_IN: 'WORK_TIME_IN',
    WORK_TIME_OUT: 'WORK_TIME_OUT',
    BREAK_TIME_IN: 'BREAK_TIME_IN',
    BREAK_TIME_OUT: 'BREAK_TIME_OUT',
    PLAY: 'PLAY',
    BREAK: 'BREAK',
    BREAK_IN: 'BREAK_IN',
    BREAK_OUT: 'BREAK_OUT',
    DATA_MESSAGE: 'DATA_MESSAGE',
    TIME_IN_IMAGE: 'TIME_IN_IMAGE',
    LUNCH_AFTER_IMAGE: 'LUNCH_AFTER_IMAGE',
  };
  